import { fonts, colors } from '../../styles'

export default {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		flexGrow: 1,
		textAlign: 'center'
	},
	contact: {
		fontFamily: fonts.paragraph,
		letterSpacing: '1px',
		display: 'flex',
		alignItems: 'center',
		margin: '0 8px',
		fontSize: 16,
		padding: 24,
		color: colors.white,
		lineHeight: 1
	},
	icon: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 24,
		marginRight: 16,
		paddingRight: 16,
		paddingTop: 4,
		paddingBottom: 4,
		width: 24,
		color: colors.lightGrey,
		borderRight: `1px dashed ${colors.white}`
	}
}



// WEBPACK FOOTER //
// ./src/views/Contact/styles.js